require('alpinejs');
require('./bs4-toast');
require('./ajax-messages');
require('./ajax-progress');
require('./ctrl-s');
require('./clear-form');
require('./navbar.js')